export default class DesktopHeader {
    constructor(element) {
        this.selector = element;

        this.showMenu();
        this.handleHomepageHeader();
    }

    showMenu() {
        const items = this.selector.querySelectorAll('[data-menu-item]');

        items.forEach((item) => {
            item.addEventListener('mouseover', () => {
                const container = item.closest('[data-menu-container]');

                const activeMenu = container.querySelector('[data-menu].active-menu');
                const activeItem = container.querySelector('[data-menu-item].active-item');

                const menu =  container.querySelector(`[data-menu="${item.dataset.menuItem}"]`);

                activeMenu.classList.remove('active-menu');
                activeItem.classList.remove('active-item');

                item.classList.add('active-item');
                menu.classList.add('active-menu');
            });
        });
    }

    handleHomepageHeader() {
        if (!this.selector.hasAttribute('data-homepage-header')) return;

        const onScroll = () => {
            if (window.scrollY > 50) {
                this.selector.classList.add('header-scrolled');
            } else {
                this.selector.classList.remove('header-scrolled');
            }
        };

        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
    }
}